import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
const StyledNoMIDISupport = styled.div`

   position:absolute;
   z-index:10;
   background:rgba(0,0,0,.95);
   width:100vw;
   height:100vh;
   top:0px;
   text-align:center;
   padding:20px;
   box-sizing:border-box;

`
const NoMIDISupport = ({dispatch}) => {
    if (navigator.requestMIDIAccess) {
        return null
    } else {
        return(<StyledNoMIDISupport>

            <h1>Sorry!</h1>
            <p>This website is built on Web MIDI technology which is not supported in your browser. Please use the latest version of Chrome, Opera or the Firefox Web MIDI extension.</p>
        </StyledNoMIDISupport>)
    }

}

export default connect()(NoMIDISupport)